import { isInternal } from "@/access/permissions";
import { Icon } from "@/ui/Icon";
import { useConsole } from "./ConsoleContext";
import { hrefTo } from "./hashRoute";
import type { GroupName, RouteDef } from "./routes";
import { useAssistant } from "./panels";

/** Prefetch do chunk da tela no hover/foco: o clique já encontra o código baixado. */
const prefetched = new Set<string>();
function prefetch(r: RouteDef) {
  if (prefetched.has(r.slug)) return;
  prefetched.add(r.slug);
  void r.load();
}

export function Sidebar(props: {
  routes: RouteDef[];
  groups: GroupName[];
  current: string;
  open: boolean;
  onNavigate: () => void;
}) {
  const { me } = useConsole();
  const assistant = useAssistant();
  return (
    <aside id="sidebar" className={props.open ? "open" : ""}>
      <div className="logo">
        iuvo<i>ai</i>
        <span className="console">CONSOLE</span>
      </div>
      <nav>
        {props.groups.map((g) => {
          const list = props.routes.filter((r) => r.group === g);
          if (!list.length) return null;
          return (
            <div key={g}>
              <div className="navgroup">{g}</div>
              {list.map((r) => (
                <a
                  key={r.slug}
                  href={hrefTo(r.slug)}
                  role="button"
                  className={`navlink ${props.current === r.slug ? "active" : ""}`}
                  aria-current={props.current === r.slug ? "page" : undefined}
                  onMouseEnter={() => prefetch(r)}
                  onFocus={() => prefetch(r)}
                  onClick={props.onNavigate}
                >
                  <span className="icon">
                    <Icon name={r.icon} />
                  </span>
                  {r.label}
                  {r.badge && <b>{r.badge}</b>}
                </a>
              ))}
            </div>
          );
        })}
      </nav>
      <div className="sidefoot">
        {isInternal(me) ? (
          <>
            <span className="green">●</span> Agentes ativos <b>7/7</b>
            <br />
            Uptime 30 dias <b>99,8%</b>
          </>
        ) : (
          <>
            <span className="green">●</span> Seu agente está em operação
            <br />
            Precisa de ajuda?{" "}
            <button className="link" onClick={assistant}>
              Fale com a Iuvo ↗
            </button>
          </>
        )}
        <br />
        <span className="muted">Iuvo Console · v0.1.0</span>
      </div>
    </aside>
  );
}
